<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12"  v-if="unitAttribute.default_value" :for="id">
          Price Per {{ unitAttribute.default_value }}
        </label>
        <label class="attribute-label m-bottom-12" v-else :for="id">
            Price
        </label>
        <div class="input-group width-100">
            <input type="number" step="0.01" :name="name" class="form-control price-new-inputs" v-model="numberValue">

            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
        </div>

        <b v-if="numberValue != suggestedPrice && suggestedPrice !=0" class="text-style-n">Recommended: {{ suggestedPrice.toFixed(2) }}</b>
    </div>
</template>

<script>

export default {
    name: "PriceAttribute",
    props: {
        priceAttribute: {
            type: Object,
            required: true
        },
      unitAttribute: {
            type: Object,
            required: true
        },
        service: {
            type: Object,
            required: true
        },
        currency: {
            type: Object,
            required: true
        },
        quantity: {
            type: Number,
            required: true
        },
        value: null,
        suggestedPrice: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            numberValue: this.value
        }
    },
    computed: {
        /**
         * get priceAttribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.service.service_id}${this.priceAttribute.attribute_id}_${this.service.clone}`;
            }

            return `attribute_${this.service.service_id}${this.priceAttribute.attribute_id}`;
        },
        /**
         * get priceAttribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.service.service_id}${this.priceAttribute.attribute_id}_${this.service.clone}`;
            }

            return `attribute_${this.service.service_id}${this.priceAttribute.attribute_id}`;
        },
    },
    methods: {
        setValueToSuggested() {
             console.log(this.priceAttribute);
            if (this.priceAttribute.service_attribute_value){
                this.numberValue = parseFloat(this.priceAttribute.service_attribute_value);
            }else if(this.priceAttribute.default_value){
                this.numberValue = parseFloat(this.priceAttribute.default_value);
            }else {
                this.numberValue = this.suggestedPrice
            }
        },
       safeParseInt(str) {
            if (typeof str.trim==='function') {
                const cleaned = str.trim().replace(/,/g, ''); // Remove commas

                // Check if the string consists of only digits
                if (/^\d+$/.test(cleaned)) {
                    return +cleaned;
                }
            }
    return str; // or any default/fallback value you want
}
    },
    mounted() {
        this.$nextTick(function () {
          if(!this.service.service_id)//When add new service only
            this.setValueToSuggested()
          else
            this.numberValue = parseFloat(this.priceAttribute.service_attribute_value)||0;
        })
    },
    watch: {
        value(value){
            this.numberValue = +value
        },
        numberValue(value) {
            value = this.safeParseInt(value)
                this.$emit('input', +value)
        }
    }
}
</script>

<style scoped>
.text-style-n{
    font-family: Roboto;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0em;
    color: #2E4051;
    text-align: right;
}
</style>